import { useState, useRef } from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import emailAnimation from "../../lotties/email.json";
import emailSentAnimation from "../../lotties/email-sent.json";
import Lottie from "lottie-react";
import { authService } from "../../services/auth/authService";
import { useSnackbar } from "../../context/SnackbarContext";
import { useNavigate } from "react-router-dom";
import { theme } from "../../theme/theme";
import SendEmailRecover, {
  SendEmailRecoverData,
} from "../../components/SendEmailRecover";
import { motion } from "framer-motion";
import RecoverPasswordForm, {
  RecoverPasswordData,
} from "../../components/RecoverPasswordForm";
import ChangePasswordForm, {
  ChangePasswordFormData,
} from "../../components/ChangePasswordForm";

const ChangePasswordPage = () => {
  const lottieRef = useRef<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [defaultEmail, setDefaultEmail] = useState("");

  const { showSnackbar } = useSnackbar();

  const navigate = useNavigate();

  const onSubmit = async (data: ChangePasswordFormData) => {
    const { confirmNewPassword, ...rest } = data;
    if (confirmNewPassword !== rest.newPassword) {
      showSnackbar("Las contraseñas no coinciden", "error", 5000);
      return;
    }
    try {
      setIsLoading(true);
      await authService.changePassword(rest);
      showSnackbar("Contraseña cambiada correctamente", "success", 5000);
      navigate("/home");
    } catch (error: any) {
      showSnackbar(
        error.response?.data?.message || "Error al cambiar la contraseña",
        "error",
        5000
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box sx={{ p: 5 }}>
      <Card elevation={2}>
        <CardContent sx={{ p: 4 }}>
          <Box
            sx={{
              height: 300,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Lottie
              lottieRef={lottieRef}
              style={{ width: 300, height: 300 }}
              animationData={emailAnimation}
              loop={false}
              autoplay={true}
              onComplete={() => {
                if (lottieRef.current) {
                  lottieRef.current.goToAndStop(0, true);
                }
              }}
            />
          </Box>
          <ChangePasswordForm onSubmit={onSubmit} isLoading={isLoading} />
        </CardContent>
      </Card>
    </Box>
  );
};

export default ChangePasswordPage;
